var map = {
	"./Quandora.png": "sS7Z",
	"./acer.png": "xppx",
	"./apothera.png": "Uc7k",
	"./bmw.png": "6baZ",
	"./burger-king-min.png": "S3Ls",
	"./cbre-min.png": "L9N0",
	"./cbre.png": "Ofdt",
	"./conference-compass-min.png": "HxNf",
	"./demco-min.png": "+12v",
	"./docviser.png": "2I2Y",
	"./dstoq-min.png": "aEE9",
	"./ey-min.png": "EwLI",
	"./geozone-min.png": "fB9+",
	"./geozone.png": "06Gt",
	"./gsk.png": "N/fI",
	"./home-illustration-tablet.png": "tg3W",
	"./home-illustration.png": "Vb8Q",
	"./illuminateed.png": "gIKg",
	"./livebuy.png": "Z6EJ",
	"./logo-DSTOQ.png": "VAUS",
	"./logo-burger.png": "s1AX",
	"./logo-demco.png": "xPs5",
	"./logo-mari.png": "nM38",
	"./logo-pizzahut.png": "6VtO",
	"./logo-smashcut.png": "ZqXr",
	"./logo-tillster.png": "Ej1F",
	"./mari-min.png": "dZki",
	"./massmutual.png": "hw4W",
	"./parking-match.png": "BoJj",
	"./pizza-hut-min.png": "MwdZ",
	"./renaissance.png": "1Xrw",
	"./siemens.png": "vEsI",
	"./sigora-min.png": "dAuc",
	"./smashcut-min.png": "eZYN",
	"./stitch.png": "ZiU2",
	"./teachforward.png": "QdBA",
	"./tilster-min.png": "6JSw"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ThH5";